import type { LeadGender, LeadSource, LeadStatus } from '@/types/leads';

export const LEAD_STATUS_OPTIONS: { value: Exclude<LeadStatus, 'CONVERTED'>; label: string }[] = [
  { value: 'NEW', label: 'New' },
  { value: 'CALL_SCHEDULED', label: 'Call scheduled' },
  { value: 'CALLED', label: 'Called' },
  { value: 'FOLLOW_UP', label: 'Follow-up' },
  { value: 'LOST', label: 'Lost' },
];

export const LEAD_SOURCE_OPTIONS: { value: LeadSource; label: string }[] = [
  { value: 'REFERRAL', label: 'Referral' },
  { value: 'WEBSITE', label: 'Website' },
  { value: 'SOCIAL', label: 'Social media' },
  { value: 'EVENT', label: 'Event' },
  { value: 'WALK_IN', label: 'Walk-in' },
  { value: 'CORPORATE', label: 'Corporate' },
  { value: 'OTHER', label: 'Other' },
];

export const LEAD_GENDER_OPTIONS: { value: LeadGender; label: string }[] = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
  { value: 'O', label: 'Other' },
];

export const LEAD_STATUS_STYLES: Record<LeadStatus, string> = {
  NEW: 'border-sky-200 bg-sky-50 text-sky-800',
  CALL_SCHEDULED: 'border-violet-200 bg-violet-50 text-violet-800',
  CALLED: 'border-amber-200 bg-amber-50 text-amber-800',
  FOLLOW_UP: 'border-orange-200 bg-orange-50 text-orange-800',
  CONVERTED: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  LOST: 'border-gray-200 bg-gray-100 text-gray-600',
};

export const FUNNEL_STAGES: LeadStatus[] = [
  'NEW',
  'CALL_SCHEDULED',
  'CALLED',
  'FOLLOW_UP',
  'CONVERTED',
  'LOST',
];

export const LEAD_NOTE_MAX_LENGTH = 4500;

export const SEARCH_DEBOUNCE_MS = 250;

export const LEADS_ALLOWED_ROLES = [
  'SUPER_ADMIN',
  'SUPER_DOCTOR',
  'ADMIN',
  'BUSINESS_DEVELOPMENT',
  'DOCTOR',
  'PHARMACIST',
  'CLINICAL_SUPPORT',
  'OPERATIONS_SUPPORT',
  'NURSE',
  'THERAPIST',
  'HEALTH_COACH',
  'RELATIONSHIP_MANAGER',
  'RECEPTION',
  'READ_ONLY',
];

export const LEADS_WRITE_ROLES = LEADS_ALLOWED_ROLES.filter((role) => role !== 'READ_ONLY');
